import { createContext, ReactNode, useContext, useMemo } from "react";
import { ClassroomHarness } from "./ClassroomHarness";

const HarnessReactContext = createContext<ClassroomHarness | null>(null);

export function HarnessProvider({ children }: { children: ReactNode }) {
  const harness = useMemo(() => new ClassroomHarness(), []);
  return <HarnessReactContext.Provider value={harness}>{children}</HarnessReactContext.Provider>;
}

export function useHarness() {
  const ctx = useContext(HarnessReactContext);
  if (!ctx) throw new Error("useHarness must be used within HarnessProvider");
  return ctx;
}
